export const UNKNOW = -1;
export const OLD_USER_VIP = 0;
export const NEW_USER = 1;
export const OLD_USER_NOVIP = 2;



// WEBPACK FOOTER //
// ./src/constant/usertype.js